import React from "react";
import { css } from "glamor";
import TipTapViewer from "../../library/TipTapViewer";
import { spacing } from "../../library/theme";
import ConversationRecap from "./ConversationRecap";

const panelClass = css({
  border: "0.66px solid #e2e8f0",
  borderRadius: 14,
  background: "#ffffff",
  padding: spacing.m,
  display: "flex",
  flexDirection: "column",
  gap: spacing.s,
});

const labelClass = css({
  fontWeight: 600,
  fontSize: 10,
  lineHeight: "15px",
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: 0.4,
});

const contextTextClass = css({
  fontSize: 13,
  lineHeight: "22px",
  color: "#1e293b",
});

const emptyStateClass = css({
  fontSize: 12,
  lineHeight: "18px",
  color: "#94a3b8",
  fontStyle: "italic",
});

/**
 * InteractiveContextColumn
 *
 * Left column of the interactive question layout.
 * - mode "context" (default): shows only the `context` field (falling back to
 *   `promptDescription` when absent). No title, no top navigation — per the
 *   business rule for interactive questions with no stems.
 * - mode "recap": shows a read-only recap of the answered flow, so the student
 *   can revisit it while answering the stems of a hybrid interactive.
 */
export default function InteractiveContextColumn({
  question,
  mode = "context", // "context" | "recap"
  recapEntries = [],
  revealResult = false,
}) {
  if (mode === "recap") {
    return (
      <div className={panelClass} data-testid="interactive-recap-column">
        <div className={labelClass}>Fluxo respondido</div>
        <ConversationRecap entries={recapEntries} revealResult={revealResult} />
      </div>
    );
  }

  const contextContent = question?.context || question?.promptDescription;

  return (
    <div className={panelClass} data-testid="interactive-context-column">
      <div className={labelClass}>Contexto</div>
      {contextContent ? (
        <TipTapViewer content={contextContent} className={contextTextClass} />
      ) : (
        <p
          className={emptyStateClass}
          data-testid="interactive-context-empty"
        >
          Sem contexto adicional para esta questão.
        </p>
      )}
    </div>
  );
}
